export default __webpack_public_path__ + "static/media/717.926b4988.gif";